import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

interface BusinessRatingProps {
  rating: number;
  reviewsCount: number;
  reviewsUrl?: string;
  source: 'google' | 'trustpilot';
  isMobile?: boolean;
}

const BusinessRating: React.FC<BusinessRatingProps> = ({
  rating,
  reviewsCount,
  reviewsUrl,
  source,
  isMobile = false,
}) => {
  const theme = useTheme();

  const pillSx = {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    backgroundColor:
      source === 'trustpilot'
        ? 'rgba(0, 182, 122, 0.1)'
        : 'rgba(251, 192, 45, 0.1)',
    borderRadius: '5px',
    padding: theme.spacing(0.5, 1),
    fontSize: '0.875rem',
    fontWeight: 500,
    width: 'auto',
    minWidth: null,
    gap: theme.spacing(0.5),
    mb: 0,
    height: 'auto',
    boxSizing: 'border-box',
  };

  if (source === 'trustpilot') {
    return (
      <Box sx={pillSx}>
        <img
          src="https://bpgzmppocasvdjgkacsj.supabase.co/storage/v1/object/public/company-logos/trustpilot-logo.png"
          alt="Trustpilot"
          className="logo"
          style={{ height: '12px', width: 'auto' }}
        />
        <StarIcon sx={{ color: '#00B67A', fontSize: '1.1rem', ml: 1 }} />
        <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 500, ml: 0.5 }}>
          {rating}
          {reviewsUrl ? (
            <Link
              href={reviewsUrl}
              target="_blank"
              underline="hover"
              sx={{
                ml: 0.5,
                fontSize: '0.8rem',
                fontWeight: 400,
                color: 'text.secondary',
                '&:hover': { color: '#00B67A' },
              }}
            >
              ({reviewsCount} reviews)
            </Link>
          ) : (
            <Typography
              component="span"
              color="text.secondary"
              sx={{
                ml: 0.5,
                fontSize: '0.8rem',
                fontWeight: 400,
              }}
            >
              ({reviewsCount} reviews)
            </Typography>
          )}
        </Typography>
      </Box>
    );
  }

  if (source === 'google') {
    return (
      <Box sx={pillSx}>
        <img
          src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"
          alt="Google"
          className="logo"
          style={{ height: '16px', width: 'auto' }}
        />
        <StarIcon sx={{ color: '#FBC02D', fontSize: '1.1rem', ml: 1 }} />
        <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 500, ml: 0.5 }}>
          {rating}
          {reviewsUrl ? (
            <Link
              href={reviewsUrl}
              target="_blank"
              underline="hover"
              sx={{
                ml: 0.5,
                fontSize: '0.8rem',
                fontWeight: 400,
                color: 'text.secondary',
                '&:hover': { color: '#4285F4' },
              }}
            >
              ({reviewsCount} reviews)
            </Link>
          ) : (
            <Typography
              component="span"
              color="text.secondary"
              sx={{
                ml: 0.5,
                fontSize: '0.8rem',
                fontWeight: 400,
              }}
            >
              ({reviewsCount} reviews)
            </Typography>
          )}
        </Typography>
      </Box>
    );
  }

  return null;
};

export default BusinessRating; 